<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="col-1 p-0">
        <app-side-nav [item]="meetingNav"></app-side-nav>
    </div> -->
  <div class="col-12 p-0 container-fluid reports-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">
      <div class="breadcrumbs-section padding-report" *ngIf="fromDetails">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Reports</span>
      </div>

      <div class="breadcrumbs-section" *ngIf="!fromDetails">
        <span class="prev-page pb-1 "><a routerLink="/overview">Home</a></span>
        <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
        <span class="prev-page  "><a routerLink="/companies/companies-list">Companies</a></span>
        <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
        <span class="prev-page"><a routerLink="/companies/companies-list/company-details">Company Details</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Reports</span>
      </div>

      <div class="d-flex justify-content-between padding-report-heading pb-3 pl-5 ml-2">
        <div class="meeting-room-report pointer-link col-10" (clickOutside)="onClickedOutside($event)"
          [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual" #pr="ngbPopover" (click)="openPopover(pr)"
          placement="bottom" popoverClass='dash-popover1 dashboard-popover1'>
          <span *ngIf="selectedIndex==4">Meeting Room - Admin Report</span>
          <span *ngIf="selectedIndex==3">Meeting Room - Employee Report</span>
          <span *ngIf="selectedIndex==2">Membership Report</span>
          <span *ngIf="selectedIndex==1">Check-in Report</span>
          <span *ngIf="selectedIndex==0">Credit Usage Report</span>
          <span *ngIf="selectedIndex==5">Feedback Report</span>
          <span *ngIf="selectedIndex==6">VMS Report</span>
          <span *ngIf="selectedIndex==7">Events Report</span>
          <span *ngIf="selectedIndex==8">Member Card Report</span>
          <!-- <span *ngIf="selectedIndex==9">Survey Report</span>
          <span *ngIf="selectedIndex==10">Facility Report</span>
          <span *ngIf="selectedIndex==11">Employee Report</span> -->
          <img src="../../assets/images/reportDropdown.png" class="padding-left-image pr-1" loading="lazy" />
        </div>
        <div>
          <ng-template #popContent>
            <div class="dashboard-popover1 ">
              <div class="">
                <div class="">
                  <div class="row pb-3 d-flex justify-content-between pointer-link"
                    *ngFor="let report of ((prod==true)?prodReportsList:reportsList);let i=index"
                    (click)="selectedReportType(report.index);openPopover(pr)">
                    <div class="popover-content pl-3 email-width" [class]="selectedIndex==i?'bold-font':'normal-font'">
                      {{report.type}}
                    </div>
                    <div>
                      <img src="/assets/images/tick.png" *ngIf="selectedIndex==i" class="pl-4" loading="lazy" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>

        <div
          *ngIf="!((selectedIndex==11 && listEmployee?.length == 0) || (selectedIndex==10 && listFacility?.length == 0) || (selectedIndex==9 && listSurvey?.length == 0) || (selectedIndex==8 && listfrids?.length == 0) || (selectedIndex==6 && vmsList?.length == 0) || (selectedIndex==7 && eventList?.length == 0) || (selectedIndex==4 && meetings?.length == 0) || (selectedIndex==3 && meetings?.length == 0) || (selectedIndex==2 && memberships?.length == 0) || (selectedIndex==1 && checkIns?.length == 0) || (selectedIndex==0 && creditPoints?.length == 0)) && selectedIndex!=5">
          <div class="col-2" [ngbPopover]="popDownloadContent" triggers="manual" #pd="ngbPopover"
            (click)="openPopover(pd)" popoverClass='dnload-popover download-popover' *ngIf="reportsLoaded">
            <button type="button " class="add-button"><span class="add">Download
                Report&nbsp;&nbsp;&#9660;</span></button>
          </div>
        </div>

        <div class="col-2" *ngIf="selectedIndex==5">
          <button type="button" class="add-button">
            <a href="{{ downloadFeedbackReport() }}" download><span class="add">Download
                Report&nbsp;&nbsp;&#9660;</span></a></button>
        </div>

        <div>
          <ng-template #popDownloadContent>
            <div class="download-popover">
              <div class="">
                <div class="">
                  <div class="row pb-3 d-flex justify-content-between pointer-link"
                    *ngFor="let downloadTypes of DownloadTypes"
                    (click)="selectedReportDownload(downloadTypes);openPopover(pd)">
                    <div class="popover-content pl-3 email-width"
                      [class]="SelectedDownloadReportType.includes(downloadTypes?.id) ?'bold-font':'normal-font'">
                      {{downloadTypes.type}}
                    </div>
                    <div>
                      <img src="/assets/images/tick.png"
                        *ngIf="SelectedDownloadReportType.includes(downloadTypes.id) || (downloadTypes.id == null && SelectedDownloadReportType.length == 0)"
                        class="pl-4" loading="lazy" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
      <div class="col-12 d-flex justify-content-start row borders m-0 p-0 ">
        <div class="col-3  borders-right d-flex justify-content-between relative-content">

          <div class="pt-3 pb-3 " *ngIf="selectedIndex==4" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popMeetingRooms" triggers="manual" #p1="ngbPopover"
            (click)="openPopover(p1)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-left usage-for"> Meeting Room
            <img src="../../assets/images/Path.png" class="pr-3 access-point-arrow" loading="lazy" />
            <div class="font"> {{multiSelectionMeetingRoom.length>1?selectedMeetingRoom+" +"+
              selctionlength :selectedMeetingRoom}}</div>

            <div>
              <ng-template #popMeetingRooms>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let meetingroom of meetingRooms;let i=index" (click)="selectMeetingRoom(meetingroom);">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionMeetingRoom.includes(meetingroom?.id) ?'bold-font':'normal-font'">
                          {{meetingroom.name}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionMeetingRoom.includes(meetingroom.id) || (meetingroom.id == null && multiSelectionMeetingRoom.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>
          </div>
          <div class="pt-3 pb-3 " *ngIf="selectedIndex==3" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popMeetingRooms" triggers="manual" #p1="ngbPopover"
            (click)="openPopover(p1)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-left usage-for"> Meeting Room
            <img src="../../assets/images/Path.png" class="pr-3 access-point-arrow" loading="lazy" />
            <div class="font"> {{multiSelectionMeetingRoom.length>1?selectedMeetingRoom+" +"+
              selctionlength :selectedMeetingRoom}}</div>

            <div>
              <ng-template #popMeetingRooms>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let meetingroom of meetingRooms;let i=index" (click)="selectMeetingRoom(meetingroom);">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionMeetingRoom.includes(meetingroom?.id) ?'bold-font':'normal-font'">
                          {{meetingroom.name}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionMeetingRoom.includes(meetingroom.id) || (meetingroom.id == null && multiSelectionMeetingRoom.length == 0)"
                            class="pl-4 " loading="lazy" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>
          </div>

          <div class="pt-3 pb-3" *ngIf="selectedIndex==2" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popOrganization" triggers="manual" #p2="ngbPopover"
            (click)="openPopover(p2)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-left usage-for"> Organization
            <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <div class="font">{{multiSelectionOrganizations.length>1?selectedOrganzation+" +"+ selctionlength
              :selectedOrganzation}}</div>
            <div>
              <ng-template #popOrganization>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let tenant of tenants ;let i=index" (click)="selectOrgatization(tenant)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionOrganizations.includes(tenant?.id) ?'bold-font':'normal-font'">
                          {{tenant.companyName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionOrganizations.includes(tenant.id) || (tenant.id == null && multiSelectionOrganizations.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>


          <div class="pt-3 pb-3" *ngIf="selectedIndex==8" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popOrganization" triggers="manual" #p2="ngbPopover"
            (click)="openPopover(p2)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-left usage-for"> Organization
            <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <div class="font">{{multiSelectionOrganizations.length>1?selectedOrganzation+" +"+ selctionlength
              :selectedOrganzation}}</div>
            <div>
              <ng-template #popOrganization>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let tenant of tenants ;let i=index" (click)="selectOrgatizationRfid(tenant)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionOrganizations.includes(tenant?.id) ?'bold-font':'normal-font'">
                          {{tenant.companyName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionOrganizations.includes(tenant.id) || (tenant.id == null && multiSelectionOrganizations.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="pt-3 pb-3" *ngIf="selectedIndex==9" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popSurvey" triggers="manual" #p2="ngbPopover"
            (click)="openPopover(p2)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-left usage-for"> Survey Type
            <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <div class="font">{{selctionlength >= 1 ? selectedSurveyName+" +"+ selctionlength : selectedSurveyName}}
            </div>
            <div>
              <ng-template #popSurvey>
                <div class="dashboard-popover">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let svtype of mainSurveyTypes ;let i=index" (click)="selectOrgatizationSurvey(svtype)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionOrganizations.includes(svtype?.surveyTypeId) ?'bold-font':'normal-font'">
                          {{svtype.surveyTypeName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionOrganizations.includes(svtype.surveyTypeId) || (svtype.surveyTypeId == null && multiSelectionOrganizations.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="pt-3 pb-3" *ngIf="selectedIndex==10" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popFacility" triggers="manual" #p2="ngbPopover"
            (click)="openPopover(p2)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-left usage-for"> Facility Type
            <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <!-- <div class="font">{{selctionlength >= 1 ? selectedFacilityName+" +"+ selctionlength : selectedFacilityName}}</div> -->
            <div class="font">{{selectedFacilityName}}</div>
            <div>
              <ng-template #popFacility>
                <div class="dashboard-popover">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let fatype of mainFacilityTypes ;let i=index"
                        (click)="selectOrgatizationFacility(fatype)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionOrganizations.includes(fatype?.facilityTypeId) ?'bold-font':'normal-font'">
                          {{fatype.facilityTypeName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionOrganizations.includes(fatype.facilityTypeId) || (fatype.facilityTypeId == null && multiSelectionOrganizations.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="pt-3 pb-3" *ngIf="selectedIndex==11" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popEmployeeReport" triggers="manual" #p2="ngbPopover"
            (click)="openPopover(p2)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-left usage-for"> VMS Status
            <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <!-- <div class="font">{{selctionlength >= 1 ? selectedFacilityName+" +"+ selctionlength : selectedFacilityName}}</div> -->
            <div class="font">{{selectedEmployeeName}}</div>
            <div>
              <ng-template #popEmployeeReport>
                <div class="dashboard-popover">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let fatype of mainEmployeeTypes ;let i=index"
                        (click)="selectOrgatizationEmployee(fatype)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionOrganizations.includes(fatype?.employeeReportId) ?'bold-font':'normal-font'">
                          {{fatype.employeeReportName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionOrganizations.includes(fatype.employeeReportId) || (fatype.employeeReportId == null && multiSelectionOrganizations.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="pt-3 pb-3 " style="top: 40px;" *ngIf="selectedIndex==1" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popAccessPoints" triggers="manual" #p3="ngbPopover"
            (click)="openPopover(p3)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-left usage-for"> Access Point
            <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <div class="font"> {{multiSelectionAccessPoints.length>1?selectedAccessPoint+" +"+
              selctionlength :selectedAccessPoint}}</div>

            <div>
              <ng-template #popAccessPoints>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let access of accessPoints ;let i=index" (click)="selectAccessPoint(access)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionAccessPoints.includes(access?.id) ?'bold-font':'normal-font'">
                          {{access.accessPointName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionAccessPoints.includes(access.id) || (access.id == null && multiSelectionAccessPoints.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>

          </div>

          <div class="pt-3 pb-3 pl-5" *ngIf="selectedIndex==0" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popCreditAccess" triggers="manual" #p0="ngbPopover"
            (click)="openPopover(p0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-left  pl-5">
            <div class="text">View usage for</div>

            <div class="meeting-sub-label">{{selectedUsageType}} <img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>
            <div>
              <ng-template #popCreditAccess>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let Usagetype of Usagetypes ;let i=index"
                        (click)="selectCreditUsage(Usagetype);openPopover(p0)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionCreditUsageType.includes(Usagetype?.id) ?'bold-font':'normal-font'">
                          {{Usagetype.type}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionCreditUsageType.includes(Usagetype?.id) || (Usagetype?.id == null  && multiSelectionCreditUsageType.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>


          <!-- vms -->

          <div class="pt-5 pb-3 pl-5" *ngIf="selectedIndex==6" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popInviteType" triggers="manual" #p0="ngbPopover"
            (click)="openPopover(p0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-left usage-for pl-5">
            <div class="text">Invite Type</div>

            <!-- <div class="meeting-sub-label">{{multiSelectionInvitationType.length>1?selectedType+" +"+
            selctionlength :selectedType}} <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow"
                loading="lazy" /></div> -->

            <div class="meeting-sub-label">{{multiSelectionInvitationType.length>1?formatString(selectedType)+" +"+
              selctionlength :formatString(selectedType)}} <img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>


            <div>
              <ng-template #popInviteType>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let invite of invitationTypes;let i=index"
                        (click)="selectInviteType(invite);openPopover(p0)">
                        <div class="popover-content pl-3 email-width" style="width: 150px;"
                          [class]="multiSelectionInvitationType.includes(invite?.invitationTypeId) ?'bold-font':'normal-font'">
                          {{formatString(invite.invitationType)}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionInvitationType.includes(invite.invitationTypeId) || (invite.invitationTypeId == null && multiSelectionInvitationType.length == 0)"
                            class="pl-5 " loading="lazy" />
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>

          </div>



          <div class="pt-3 pb-3 pl-5" *ngIf="selectedIndex==5" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popFeedbackReport" triggers="manual" #p0="ngbPopover"
            (click)="openPopover(p0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-left  pl-5">
            <div class="text">View report for</div>

            <div class="meeting-sub-label">{{selectedFRType}} <img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>
            <div>
              <ng-template #popFeedbackReport>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let Usagetype of FRtypes ;let i=index" (click)="selectFR(Usagetype);openPopover(p0)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionFRType.includes(Usagetype?.id) ?'bold-font':'normal-font'">
                          {{Usagetype.type}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionFRType.includes(Usagetype?.id) || (Usagetype?.id == null  && multiSelectionFRType.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="pt-3 pb-3 pl-5" *ngIf="selectedIndex==7" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popEventReport" triggers="manual" #p0="ngbPopover"
            (click)="openPopover(p0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-left  pl-5">
            <div class="text">View report for</div>

            <div class="meeting-sub-label">{{selectedEType}} <img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>
            <div>
              <ng-template #popEventReport>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let type of eventType ;let i=index" (click)="selectEventType(type);openPopover(p0)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionEventType.includes(type?.eventCategoryId) ?'bold-font':'normal-font'">
                          {{type.eventCategoryName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionEventType.includes(type?.eventCategoryId) || (type?.eventCategoryId == null  && multiSelectionEventType.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>


        <div class=" pt-3 pb-3 borders-right col-2" [ngClass]="{'disbale-date': selectedIndex==11}">
          <div class="pl-3">
            <span class="meeting-label pt-3"
              style="position: absolute;padding-left: 31px;margin-top: -14px;">From</span>
            <!-- <input class="cal-icon all-hosts pt-3  pointer-link" autocomplete="off"
              (dateSelect)="updateSelectedDate($event)" (click)="d1.toggle()" readonly
              (keypress)="$event.preventDefault()" type="text" name="dp1" ngbDatepicker #d1="ngbDatepicker"> -->

            <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d1.toggle()" [(ngModel)]="fDate" ngbDatepicker
              #d1="ngbDatepicker" (dateSelect)="updateSelectedDate($event)">
            <!-- <div class="meeting-sub-label from-date">{{selectedDate}}</div> -->
            <div class="meeting-sub-label from-date">{{formattedSelectedDate}}</div>
          </div>
        </div>

        <div class="pl-3 pt-3 pb-3 col-2 borders-right" *ngIf="selectedIndex!=5"
          [ngClass]="{'disbale-date': selectedIndex==11}">
          <span class="meeting-label pt-3" style="position: absolute;padding-left: 31px;margin-top: -14px;">To</span>
          <!-- <input class="cal-icon all-hosts pt-3  pointer-link" autocomplete="off" [readonly]="true"
            (dateSelect)="updateSelectedToDate($event)" (click)="d2.toggle()" (keypress)="$event.preventDefault()"
            type="text" name="dp2" ngbDatepicker #d2="ngbDatepicker"> -->
          <input class="cal-icon all-hosts pt-3  pointer-link" [minDate]="fDate" (click)="d2.toggle()"
            [(ngModel)]="tDate" ngbDatepicker #d2="ngbDatepicker" (dateSelect)="updateSelectedToDate($event)">
          <!-- <div class="meeting-sub-label from-date">{{selectedToDate}}</div> -->
          <div class="meeting-sub-label from-date">{{formattedSelectedToDate}}</div>
        </div>

        <div [ngClass]="'col-4'">
          <label for="search" *ngIf="selectedIndex!=5">
            <img loading="lazy" [ngClass]="selectedIndex==0?'image-pos-credit':'image-pos'" class=" search-layout"
              src="/assets/images/search.png" alt="search" style="left: auto;">
            <input class="search-box search-padding placeholder-text" type="text" name="search" id="menu-search"
              placeholder="Type here to search…" [(ngModel)]="searchText" (ngModelChange)="onReportSearchChange()">
          </label>
        </div>

      </div>

      <label class="padding-report pt-2 pb-2 column-data " style="margin-top: 10px;"
        *ngIf="(selectedIndex==4 && meetings?.length > 0) || (selectedIndex==3 && meetings?.length > 0) || (selectedIndex==2 && memberships?.length > 0) || (selectedIndex==8 && listfrids?.length > 0) || (selectedIndex==9 && listSurvey?.length > 0) || (selectedIndex==10 && listFacility?.length > 0) || (selectedIndex==11 && listEmployee?.length > 0) || (selectedIndex==1 && checkIns?.length > 0) || (selectedIndex==0 && creditPoints?.length > 0)">
        {{selectedIndex==4 || selectedIndex==3 ? (meetings|filter:searchText)?.length
        : selectedIndex==2 ? ( memberships|filter:searchText)?.length
        : selectedIndex==8 ? ( listfrids|filter:searchText)?.length
        : selectedIndex==9 ? ( listSurvey|filter:searchText)?.length
        : selectedIndex==10 ? ( listFacility|filter:searchText)?.length
        : selectedIndex==11 ? ( listEmployee|filter:searchText)?.length
        : selectedIndex==1 ? (checkIns|filter:searchText)?.length
        : (creditPoints|filter:searchText)?.length}} result(s) found for you
      </label>

      <label class="padding-report pt-2 pb-2 column-data " style="margin-top: 10px;"
        *ngIf="(selectedIndex==6 && totalVMSCount > 0)">
        {{totalVMSCount}} results found for you
      </label>

      <label class="padding-report pt-2 pb-2 column-data " style="margin-top: 10px;"
        *ngIf="(selectedIndex==7 && totalEventCount > 0)">
        {{totalEventCount}} results found for you
      </label>
      <empty-state
        *ngIf="reportsLoaded && ((selectedIndex==4 && meetings?.length == 0) || (selectedIndex==3 && meetings?.length == 0) || (selectedIndex==2 && memberships?.length == 0) || (selectedIndex==8 && listfrids?.length == 0) || (selectedIndex==9 && listSurvey?.length == 0) || (selectedIndex==10 && listFacility?.length == 0) || (selectedIndex==11 && listEmployee?.length == 0) || (selectedIndex==1 && checkIns?.length == 0) || (selectedIndex==0 && creditPoints?.length == 0)||(selectedIndex==6 && vmsList?.length == 0))">
      </empty-state>
      <empty-state *ngIf="(selectedIndex==7 && eventList?.length == 0)"></empty-state>
    </div>

    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==3  && meetings?.length > 0"
      [ngClass]="{'horizontal-scrollable': meetings.length>0}">
      <table class="table table-borderless table-curved" *ngIf="meetings.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2"> Sr.No<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('srNo',meetings)"></th>
            <th scope="col">Meeting Room<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('meetingRoomName',meetings)"></th>
            <th scope="col">Membership type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('userType',meetings)"></th>
            <th scope="col">Organization Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('organisation',meetings)"></th>
            <th scope="col">Member Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',meetings)"></th>
            <th scope="col">Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('dateOfMeeting',meetings)"></th>
            <th scope="col">Start Time<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('startTime',meetings)"></th>
            <th scope="col">Duration<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('duration',meetings)"></th>
            <th scope="col">Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('status',meetings)"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let meeting of meetings | filter:searchText | paginate: { itemsPerPage: 10,
        currentPage: page,
        totalItems:(meetings|filter:searchText)?.length };let i=index; " [ngClass]="i%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{meeting.srNo}}</td>
            <td>{{meeting.meetingRoomName}}</td>
            <td>{{meeting.userType}}</td>
            <td>{{meeting.organisation}}</td>
            <td>{{meeting.employeeName}}</td>
            <td>{{(meeting.dateOfMeeting) }}</td>
            <td>{{meeting.startTime}}</td>
            <td>{{meeting.duration}} hours</td>
            <td>{{meeting.status}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- admin table -->

    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==4 && meetings?.length > 0 "
      [ngClass]="{'horizontal-scrollable': meetings.length>0}">
      <table class="table table-borderless table-curved  " *ngIf="meetings.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2"> Sr.No<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('srNo',meetings)"></th>
            <th scope="col">Meeting Room<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('meetingRoomName',meetings)"></th>
            <th scope="col">Membership type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('userType',meetings)"></th>
            <th scope="col">Organization Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('organisation',meetings)"></th>
            <th scope="col">Admin Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('bookedBy',meetings)"></th>
            <th scope="col">Member Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',meetings)"></th>
            <th scope="col">Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('dateOfMeeting',meetings)"></th>
            <th scope="col">Start Time<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('startTime',meetings)"></th>
            <th scope="col">Duration<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('duration',meetings)"></th>
            <th scope="col">Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('status',meetings)"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let meeting of meetings | filter:searchText | paginate: { itemsPerPage: 10,
        currentPage: page,
        totalItems:(meetings|filter:searchText)?.length };let i=index; " [ngClass]="i%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{meeting.srNo}}</td>
            <td>{{meeting.meetingRoomName}}</td>
            <td>{{meeting.userType}}</td>
            <td>{{meeting.organisation}}</td>
            <td>{{meeting.bookedBy}}</td>
            <td>{{meeting.employeeName}}</td>
            <td>{{(meeting.dateOfMeeting )}}</td>
            <td>{{meeting.startTime}}</td>
            <td>{{meeting.duration}} hours</td>
            <td>{{meeting.status}}</td>
          </tr>
        </tbody>
      </table>
    </div>


    <!-- admin table end -->

    <div class=" scroll-content " *ngIf="selectedIndex==2  && memberships?.length > 0"
      [ngClass]="{'horizontal-scrollable-check-in': memberships?.length>0}">
      <table class="table table-borderless table-curved  " *ngIf="memberships?.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2">Sr.No<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('srNo',memberships)"></th>
            <th scope="col">Organization Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('organisation',memberships)"></th>
            <th scope="col">Membership type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('memberShipType',memberships)"></th>
            <th scope="col">Start Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('startDate',memberships)"></th>
            <th scope="col">End Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('endDate',memberships)"></th>
            <th scope="col">No. of members <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('noOfMembers',memberships)"></th>
            <th scope="col">Access Point<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('accessPoint',memberships)"></th>
            <th scope="col">PoC Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('pocName',memberships)"></th>
            <th scope="col">PoC Designation<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('pocDesignation',memberships)"></th>
            <th scope="col">PoC Mobile Number<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('pocMobileNo',memberships)"></th>
            <th scope="col">PoC Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('pocEmail',memberships)"></th>
            <th scope="col">Credit Points (Alloted)<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('creditPointsAllocated',memberships)"></th>
            <th scope="col">Credit Points (Purchased)<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('creditPointsPurchased',memberships)"></th>
          </tr>
        </thead>
        <tbody>
          <tr style="text-align: center;" *ngFor="let membership of memberships | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: page,
            totalItems:(memberships|filter:searchText)?.length } ;let i=index;" [ngClass]="i%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{membership.srNo}}</td>
            <td>{{membership.organisation}}</td>
            <td>{{membership.memberShipType}}</td>
            <td>{{(membership.startDate)}}</td>
            <td>{{(membership.endDate)}}</td>
            <td>{{membership.noOfMembers}}</td>
            <td style="word-break: break-all;white-space: break-spaces;">{{membership.accessPoint }}</td>
            <td>{{membership.pocName }}</td>
            <td>{{membership.pocDesignation }}</td>
            <td>{{membership.pocMobileNo}}</td>
            <td>{{membership.pocEmail }}</td>
            <td>{{membership.creditPointsAllocated }}</td>
            <td>{{membership.creditPointsPurchased }}</td>
          </tr>
        </tbody>
      </table>
    </div>


    <div class="scroll-content" *ngIf="selectedIndex==8  && listfrids?.length > 0"
      [ngClass]="{'horizontal-scrollable-check-in': listfrids?.length>0}">
      <table class="table table-borderless table-curved" *ngIf="listfrids?.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2">Sr.No<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('srNo',listfrids)"></th>
            <th scope="col">Organization Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('organizationName',listfrids)"></th>
            <th scope="col">Member Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('memberName',listfrids)"></th>
            <th scope="col">Member Mobile<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('memberMobile',listfrids)"></th>
            <th scope="col">Member Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('memberEmail',listfrids)"></th>
            <th scope="col">Card Serial Number<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('memberCardNo',listfrids)"></th>
            <th scope="col">Assinged On<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('assignedOn',listfrids)"></th>
            <th scope="col">Deallocation Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('deAllocationDate',listfrids)"></th>
          </tr>
        </thead>
        <tbody>
          <tr style="text-align: center;" *ngFor="let listfrid of listfrids | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: pageNo, totalItems:(listfrids|filter:searchText)?.length } ;let i=index;" [ngClass]="i%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{listfrid.srNo}}</td>
            <td>{{listfrid.organizationName}}</td>
            <td><span *ngIf="listfrid.memberName!='null'">{{listfrid.memberName}}</span><span
                *ngIf="listfrid.memberName==null">-</span></td>
            <td><span *ngIf="listfrid.memberMobile!='null'">{{listfrid.memberMobile}}</span><span
                *ngIf="listfrid.memberMobile==null">-</span></td>
            <td>{{listfrid.memberEmail ?? 'NA'}}</td>
            <td>{{(listfrid.memberCardNo)}}</td>
            <td>{{formatDateAll(listfrid.assignedOn,'date')}}</td>
            <td>{{formatDateAll(listfrid.deAllocationDate,'date')}}</td>
          </tr>
        </tbody>
      </table>
    </div>


    <div class="scroll-content" *ngIf="selectedIndex==9  && listSurvey?.length > 0"
      [ngClass]="{'horizontal-scrollable-check-in': listSurvey?.length>0}">
      <table class="table table-borderless table-curved" *ngIf="listSurvey?.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2">Sr.No<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('srNo',listSurvey)"></th>
            <th scope="col">Survey Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('surveyName',listSurvey)"></th>
            <th scope="col">Survey Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('surveyType',listSurvey)"></th>
            <th scope="col">Start Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('startDate',listSurvey)"></th>
            <th scope="col">End Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('endDate',listSurvey)"></th>
            <!-- <th scope="col">Coupon Assinged<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('couponAssigned',listSurvey)"></th> -->
            <th scope="col">Park Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('parkName',listSurvey)"></th>
            <th scope="col" class="building-list">Building Name<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('buildingNames',listSurvey)"></th>
            <th scope="col" class="tenant-list">Tenant Name<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('tenantNames',listSurvey)"></th>
            <th scope="col">Download Report</th>
          </tr>
        </thead>
        <tbody>
          <tr style="text-align: center;" *ngFor="let survey of listSurvey | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: page, totalItems:(listSurvey|filter:searchText)?.length } ;let i=index;"
            [ngClass]="i%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{i + 1}}</td>
            <td>{{survey.surveyName}}</td>
            <td>{{survey.surveyType}}</td>
            <td>{{formatDateAll(survey?.startDate,'date')}}</td>
            <td>{{formatDateAll(survey?.endDate,'date')}}</td>
            <!-- <td>{{survey.couponAssigned}}</td> -->
            <!-- <td>{{survey.parkName}}</td> -->
            <td class="park-list"><span *ngFor="let park of survey?.parkNames; let last = last">{{park}}{{ !last ? ', '
                : ''
                }}</span></td>
            <td class="building-list"><span
                *ngFor="let building of survey?.buildingNames; let last = last">{{building}}{{ !last ? ', ' : ''
                }}</span></td>
            <td class="tenant-list"><span *ngFor="let tenant of survey?.tenantNames; let last = last">{{tenant}}{{ !last
                ? ', ' : '' }}</span></td>
            <td><a [attr.href]="reportDownloadUrl(survey?.surveyId)" download><i class="fa fa-download"
                  aria-hidden="true"></i></a></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-content" *ngIf="selectedIndex==10  && listFacility?.length > 0"
      [ngClass]="{'horizontal-scrollable-check-in': listFacility?.length>0}">
      <table class="table table-borderless table-curved" *ngIf="listFacility?.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2">Sr.No<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('srNo',listFacility)"></th>
            <th scope="col">Faclity Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('facilityName',listFacility)"></th>
            <th scope="col">Facility Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('facilityTypeName',listFacility)"></th>
            <th scope="col">Facility Capacity<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('facilityCapacity',listFacility)"></th>
            <th scope="col">Park Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('parkName',listFacility)"></th>
            <th scope="col">Hourly Rate<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('rateHourly',listFacility)"></th>
            <th scope="col">Additional Hourly Rate<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('additionalHourRate',listFacility)"></th>
            <th scope="col">Daily Rate<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('dailyRate',listFacility)"></th>
            <th scope="col">Additional Daily Rate<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('additionalDayRate',listFacility)"></th>
            <th scope="col">Security Deposit<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('securityDeposit',listFacility)"></th>
            <th scope="col">Booking Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('bookingTypeName',listFacility)"></th>
            <th scope="col">Start Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('startDateTime',listFacility)"></th>
            <th scope="col">End Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('endDateTime',listFacility)"></th>
            <th scope="col">Duration(Hours)<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('duration',listFacility)"></th>
            <th scope="col">Total Amount<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('totalAmount',listFacility)"></th>
            <th scope="col">Created By<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('createdBy',listFacility)"></th>
            <th scope="col">Payment Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('paymentStatus',listFacility)"></th>
            <th scope="col">Refund Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('refundStatus',listFacility)"></th>
          </tr>
        </thead>
        <tbody>
          <tr style="text-align: center;" *ngFor="let facility of listFacility | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: page, totalItems:(listFacility|filter:searchText)?.length } ;let i=index;"
            [ngClass]="i%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{i + 1}}</td>
            <td>{{facility?.facilityName}}</td>
            <td>{{facility?.facilityTypeName}}</td>
            <td>{{facility?.facilityCapacity}}</td>
            <td>{{facility?.parkName}}</td>
            <td>₹{{facility?.rateHourly}}</td>
            <td>₹{{facility?.additionalHourRate}}</td>
            <td>₹{{facility?.dailyRate}}</td>
            <td>₹{{facility?.additionalDayRate}}</td>
            <td>₹{{facility?.securityDeposit}}</td>
            <td>{{facility?.bookingTypeName}}</td>
            <td>{{formatDateAll(facility?.startDateTime,'date')}} {{formatTimeAll(facility?.startDateTime,'time')}}</td>
            <td>{{formatDateAll(facility?.endDateTime,'date')}} {{formatTimeAll(facility?.endDateTime,'time')}}</td>
            <td>{{facility?.duration}}</td>
            <td>₹{{facility?.totalAmount}}</td>
            <td>{{facility?.createdBy}}</td>
            <td>{{facility?.paymentStatus}}</td>
            <td>{{facility?.refundStatus}}</td>
          </tr>
        </tbody>
      </table>
    </div>


    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==11 && listEmployee?.length > 0"
      [ngClass]="{'horizontal-scrollable': listEmployee.length>0}">
      <table class="table table-borderless table-curved" *ngIf="listEmployee.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',eventList)"></th>
            <th scope="col">Company<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('ertName',eventList)"></th>
            <th scope="col">Employee Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedEmployeeName',eventList)"></th>
            <th scope="col">Verification status <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedDate',eventList)"></th>
            <th scope="col">VMS Status <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedTime',eventList)"></th>

            <th scope="col">Mobile Number<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeEmail',eventList)"></th>
            <th scope="col">Employee Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',eventList)"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of listEmployee | filter:searchText  | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:(listEmployee|filter:searchText)?.length }; let i=index " [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{((indexPage-1)*10)+(i+1)}}</td>
            <td>{{emp.companyName}}</td>
            <td>{{emp.employeeName}}</td>
            <td>{{emp.verificationStatus}}</td>
            <td>{{emp.vmsStatus}}</td>
            <td>{{emp.mobileNumber }}</td>
            <td>{{emp.employeeEmail}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==6 && vmsList?.length > 0"
      [ngClass]="{'horizontal-scrollable': vmsList?.length>0}">
      <table class="table table-borderless table-curved   " *ngIf="vmsList?.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',vmsList)"></th>
            <th scope="col">System Record Id<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('systemRecordId',vmsList)"></th>
            <th scope="col">Badge no.<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('badgeNumber',vmsList)"></th>
            <th scope="col">Visitor Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('visitorName',vmsList)"></th>
            <th scope="col">Visitor Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('visitorEmail',vmsList)"></th>
            <th scope="col">Visitor Mobile No <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('visitorMobileNumber',vmsList)"></th>
            <th scope="col">Invite Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('inviteType',vmsList)"></th>
            <th scope="col">Visitor Company<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('visitorCompany',vmsList)"></th>
            <th scope="col">Visitor Vehicle Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('visitorVehicleType',vmsList)"></th>
            <th scope="col">Visitor Vehicle Number<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('visitorVehicleNumber',vmsList)"></th>
            <th scope="col">Date of Visit<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('dateOfVisit',vmsList)"></th>
            <th scope="col">Time-in<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('timeIn',vmsList)"></th>
            <th scope="col">Time-out<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('timeOut',vmsList)"></th>
            <th scope="col">Badge Returned Status <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('badgeReturnedStatus',vmsList)"></th>
            <th scope="col">Host Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('hostName',vmsList)"></th>
            <th scope="col">Host Company<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('badgeReturnedStatus',vmsList)"></th>
            <th scope="col">Host Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('hostEmail',vmsList)"></th>
            <th scope="col">Host Mobile no<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('hostMobileno',vmsList)"></th>
            <th scope="col">Invite Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('invitationType',vmsList)"></th>
            <th scope="col">Purpose<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('purpose',vmsList)"></th>
            <th scope="col">Purpose Category<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('purposeCategory',vmsList)"></th>
            <th scope="col">Park Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('parkName',vmsList)"></th>
            <th scope="col">Building Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('building ',vmsList)"></th>
            <th scope="col">Photo Id Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('photoId ',vmsList)"></th>
            <th scope="col">Gate No.<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('gateNo ',vmsList)"></th>
            <th scope="col">Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('status ',vmsList)"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let vms of vmsList | filter:searchText  | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:totalVMSCount};let j=index " [ngClass]="j%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{((page-1)*10)+(j+1)}}</td>
            <td>{{vms.systemRecordId}}</td>
            <td>{{vms?.badgeNumber}}</td>
            <td>{{vms.visitorName}}</td>
            <td>{{vms.visitorEmail }}</td>
            <td><span
                *ngIf="vms.visitorMobileNumber">+91</span>{{vms.visitorMobileNumber.length>10?vms.visitorMobileNumber.substring(3):vms.visitorMobileNumber}}
            </td>
            <td>{{vms.inviteType }}</td>
            <td>{{vms.visitorCompany}}</td>
            <td>{{vms.visitorVehicleType }}</td>
            <td>{{vms?.visitorVehicleNumber}}</td>
            <td>{{vms.dateOfVisit}}</td>
            <td>{{vms.timeIn}}</td>
            <td>{{vms.timeOut}}</td>
            <td>{{vms.badgeReturnedStatus}}</td>
            <td>{{vms.hostName}}</td>
            <td>{{vms.hostCompany}}</td>
            <td>{{vms.hostEmail}}</td>
            <td><span
                *ngIf="vms.hostMobileno">+91</span>{{vms.hostMobileno?.length>10?vms.hostMobileno.substring(3):vms.hostMobileno}}
            </td>
            <td>{{formatString(vms.invitationType)}}</td>
            <td>{{vms.purpose}}</td>
            <td>{{vms.purposeCategory}}</td>

            <td>{{vms.parkName}}</td>
            <td>{{vms.building}}</td>
            <td>{{vms?.photoIdType}}</td>
            <td>{{vms.gateNo}}</td>
            <td>{{formatString(vms.invitationType)=='Bulk Invite'?vms?.status:''}}</td>

          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==7 && eventList?.length > 0"
      [ngClass]="{'horizontal-scrollable': eventList?.length>0}">
      <table class="table table-borderless table-curved   " *ngIf="eventList?.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',eventList)"></th>
            <th scope="col">Event Title <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('ertName',eventList)"></th>
            <th scope="col">Event Category<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedEmployeeName',eventList)"></th>

            <th scope="col">Park<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedDate',eventList)"></th>
            <th scope="col">Attendee Type <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedDate',eventList)"></th>
            <th scope="col">Event Start Date <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('startDate',eventList)"></th>
            <th scope="col">Event End Date <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('endDate',eventList)"></th>
            <!-- <th scope="col">Event Participation Type <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedDate',eventList)"></th> -->
            <!-- <th scope="col">Team Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',eventList)"></th> -->

            <!-- <th scope="col">Count of Participants<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedDate',eventList)"></th> -->
            <th scope="col">Attendee Company<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedTime',eventList)"></th>
            <!-- <th scope="col">Participant Captain Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedTime',eventList)"></th> -->
            <!-- <th scope="col">Captain’s Contact Number<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('employeeEmail',eventList)"></th> -->
            <!-- <th scope="col">Captain’s Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeMobile',eventList)"></th> -->
            <th scope="col">Attendee Name(s)<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeMobile',eventList)"></th>
            <th scope="col">Attendee Email(s)<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeMobile',eventList)"></th>
            <th scope="col">Attendee Phone Number(s)<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('employeeMobile',eventList)"></th>
            <th scope="col">Attendance<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeMobile',eventList)"></th>
            <!-- <th scope="col">Feedback<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeMobile',eventList)"></th> -->
            <th scope="col">Event initiated By<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('employeeMobile',eventList)"></th>
            <th scope="col">Location<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('location',eventList)"></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let event of eventList | filter:searchText  | paginate: { itemsPerPage: 10,
            currentPage: page,
            totalItems:totalEventCount }; let j=index " [ngClass]="j%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{((page-1)*10)+(j+1)}}</td>
            <td>{{event?.eventTitle}}</td>
            <td>{{event?.eventCategory}}</td>
            <td>{{event?.parkName}}</td>
            <td>{{event?.participantType}}</td>
            <td>{{event?.startDate}}</td>
            <td>{{event?.endDate}}</td>
            <!-- <td>{{event?.eventParticipantType}}</td>
              <td>{{event?.teamName}}</td>
              <td>{{event?.participantsCount}}</td> -->
            <td>{{event?.participantsCompany}}</td>
            <!-- <td>{{event?.captain?.name}}</td>
              <td>{{event?.captain?.phone}}</td>
              <td>{{event?.captain?.email}}</td> -->
            <td>{{event?.participants}}</td>
            <td>{{event?.participantsEmail}}</td>
            <td>{{event?.phoneNumber}}</td>
            <td>{{event?.attendance}}</td>
            <!-- <td>{{event?.feedback}}</td> -->
            <td>{{event?.eventCreatedBy}}</td>
            <td>{{event?.location}}</td>

          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-content " *ngIf="selectedIndex==1 && checkIns?.length > 0"
      [ngClass]="{'horizontal-scrollable-check-in': checkIns.length>0}">
      <!-- <div class="col-12-reports pt-3 d-flex text-left report-row-height  column-name header"
        *ngIf="checkIns.length > 0">
        <div class="col-1 pl-0" style="text-align: center;"  >Sr.No<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
            (click)="sort('srNo',checkIns)"></div>
        <div class="col-2">Access Point<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
            (click)="sort('accessPointName',checkIns)"></div>
        <div class="col-2">Date <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
            (click)="sort('date',checkIns)"></div>
        <div class="col-2">Check-in Time <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
            (click)="sort('timeOfCheckIn',checkIns)"></div>
          <div class="col-2">Organisation Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
              (click)="sort('organisation',checkIns)"></div>
              <div class="col-2">Member Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('memberName',checkIns)"></div>
      </div>
      <div class="col-12-reports d-flex text-left report-row-height column-data pt-3 header AltrnatieColor"
        [ngClass]="i%2==0?'row-even':'row-odd'" *ngFor="let checkIn of checkIns | filter:searchText  | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:(checkIns|filter:searchText)?.length } ">
        <div class="col-1 pl-0" style="color:rgba(64,64,64,0.6) ; text-align: center;">{{checkIn.srNo}}</div>
        <div class="col-2">{{checkIn.accessPointName}}</div>
        <div class="col-2">{{checkIn.dateOfCheckIn }}</div>
        <div class="col-2">{{convertTime(checkIn.timeOfCheckIn)}}</div>
        <div class="col-2">{{checkIn.organisation}}</div>
        <div class="col-2">{{checkIn.memberName}}</div>


      </div> -->

      <table class="table table-borderless table-curved" *ngIf="checkIns.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2">Sr.No<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('srNo',checkIns)"></th>
            <th scope="col">Access Point<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('accessPointName',checkIns)"></th>
            <th scope="col">Date <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('date',checkIns)"></th>
            <th scope="col">Check-in Time <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('timeOfCheckIn',checkIns)"></th>
            <th scope="col">Organisation Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('organisation',checkIns)"></th>
            <th scope="col">Member Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('memberName',checkIns)"></th>
            <th scope="col">Member Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('memberEmail',checkIns)"></th>
            <th scope="col">Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('status',checkIns)"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let checkIn of checkIns | filter:searchText  | paginate: { itemsPerPage: 10,
            currentPage: page,
            totalItems:(checkIns|filter:searchText)?.length };let i=index; " [ngClass]="i%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{i + 1}}</td>
            <td>{{checkIn.accessPointName}}</td>
            <td>{{(checkIn.dateOfCheckIn) }}</td>
            <td>{{checkIn?.timeOfCheckIn}}</td>
            <td>{{checkIn.organisation}}</td>
            <td>{{checkIn.memberName}}</td>
            <td>{{checkIn.memberEmail}}</td>
            <td>{{checkIn.status===true ? 'Access granted' : 'Access denied'}}</td>
          </tr>
        </tbody>
      </table>

    </div>
    <div class=" scroll-content  mb-5" *ngIf="selectedIndex==0 && creditPoints.length>0"
      [ngClass]="{'horizontal-scrollable-check-in': creditPoints.length>0}">

      <table class="table table-borderless table-curved  " *ngIf="creditPoints.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2">Sr.No<img class="pl-2" loading="lazy" src="/assets/images/sort.png" alt="search"
                (click)="sort('srNo',creditPoints)"></th>
            <th *ngIf="multiSelectionCreditUsageType==1  " scope="col">Admin Name<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('bookedBy',creditPoints)"></th>
            <th scope="col">Member Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',creditPoints)"></th>
            <th scope="col">Organisation Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('organisation',creditPoints)"></th>
            <th scope="col">Meeting Room Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('meetingRoomName',creditPoints)"></th>
            <th scope="col">Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('dateOfMeeting',creditPoints)"></th>
            <th scope="col">Duration<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('duration',creditPoints)"></th>
            <th scope="col">Credit points used<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('creditPointsUsed',creditPoints)"></th>
            <th scope="col">Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('status',creditPoints)"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let creditPoint of creditPoints | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: page,
            totalItems:(creditPoints|filter:searchText)?.length };let i=index;" [ngClass]="i%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{creditPoint.srNo}}</td>
            <td *ngIf="multiSelectionCreditUsageType==1  ">{{creditPoint.bookedBy}}</td>
            <td>{{creditPoint.employeeName}}</td>
            <td>{{creditPoint.organisation}}</td>
            <td>{{creditPoint.meetingRoomName}}</td>
            <td>{{(creditPoint.dateOfMeeting) }}</td>
            <td style=" text-align: center;">{{creditPoint.duration}} hours</td>
            <td style=" text-align: center;">{{creditPoint.creditPointsUsed}}</td>
            <td>{{creditPoint.status}}</td>
          </tr>
        </tbody>
      </table>






    </div>
    <!-- <div class="pr-3 ratio-class pt-1" *ngIf="meetingRoom?.length>=10">10/{{meetingRooms.length}}</div> -->

    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && ((selectedIndex==3 || selectedIndex==4) && meetings.length > 10)">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeMeeting($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="meetingRoom?.length>=10">10/{{meetingRooms.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{page}}/{{paginationCount(meetings.length)}}</div>
      </div>
    </div>

    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && (selectedIndex==2 && memberships?.length > 10) ">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeEmployee($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="membership?.length>=10">10/{{memberships?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{page}}/{{paginationCount(memberships?.length)}}</div>
      </div>
    </div>

    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && (selectedIndex==8 && (listfrids|filter:searchText)?.length>=10)">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeRfids($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="listfrids?.length>=10">10/{{listfrids?.length}}</div> -->
        <!-- <div class="pr-3 ratio-class pt-1">
          {{page}}/{{paginationCount(listfrids?.length)}}
        </div> -->
        <div class="pr-3 ratio-class pt-1">
          {{pageNo}}/{{fetchPage(listfrids?.length)}}
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && (selectedIndex==9 && listSurvey?.length > 10) ">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeSurvey($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="listSurvey?.length>=10">10/{{listSurvey?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{indexPage}}/{{paginationCount((listSurvey|filter:searchText)?.length)}}</div>
      </div>
    </div>

    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && (selectedIndex==10 && listFacility?.length > 10) ">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeFacility($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="listFacility?.length>=10">10/{{listFacility?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{indexPage}}/{{paginationCount((listFacility|filter:searchText)?.length)}}</div>
      </div>
    </div>

    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && (selectedIndex==11 && listEmployee?.length > 10) ">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeEmployeeReport($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="listEmployee?.length>=10">10/{{listEmployee?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{indexPage}}/{{paginationCount((listEmployee|filter:searchText)?.length)}}</div>
      </div>
    </div>

    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && (selectedIndex==1 && checkIns?.length > 10) ">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeCheckIn($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="accessPoint?.length>=10">10/{{accessPoints?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{page}}/{{paginationCount(checkIns?.length)}}</div>
      </div>
    </div>

    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && (selectedIndex==0 && creditPoints.length > 10)">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeCredit($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="creditPoint?.length>=10">10/{{creditPoints?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{page}}/{{paginationCount(creditPoints?.length)}}</div>
      </div>
    </div>

    <!-- vms -->
    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && (selectedIndex==6 && totalVMSCount>10)">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeVMS($event)" nextLabel=""
          class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="creditPoint?.length>=10">10/{{creditPoints?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{page}}/{{paginationCount(totalVMSCount)}}</div>
      </div>
    </div>

    <!-- event -->
    <!-- vms -->
    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && (selectedIndex==7 && totalEventCount>10)">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeEvent($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="creditPoint?.length>=10">10/{{creditPoints?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{page}}/{{getTotal(totalEventCount)}}</div>
      </div>
    </div>

  </div>
</div>